window.sq = window.sq || {};
window.sq.onCartAdded = function(){
    jQuery.ajax({
        type: "GET",
        url: '/',
        dataType: 'HTML',
        async: false,
        success: function(response) {
                // find the element in the response for desktop and then update the document's element
                let cartCountElements = $(response).find('.container.d-flex.flex-wrap.align-items-center.justify-content-start');
                if (cartCountElements && cartCountElements.length) {
                        let count = cartCountElements[0].innerHTML;
                        if(count){
                                Array.from($(document).find('.container.d-flex.flex-wrap.align-items-center.justify-content-start')).forEach(x => {x.innerHTML = `${count}`})
                        }
                }
           // find the element in the response for mobile and then update the document's element
                let cartCountElementsForMobile = $(response).find('.mobile-nav-item.mobile-nav-cart');
                if (cartCountElementsForMobile && cartCountElementsForMobile.length) {
                        let count = cartCountElementsForMobile[0].innerHTML;
                        if(count){
                                Array.from($(document).find('.mobile-nav-item.mobile-nav-cart')).forEach(x => {x.innerHTML = `${count}`})
                        }
                }
        }
    })
}
